class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Capture the loading indicator markup so it can be re-shown on every open
    this.loadingHTML = this.els.content.element.innerHTML
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-back-in-stock-external-el="trigger"]',
    )
    if (!trigger) return

    const content = this.els.content.element

    // Show the loading indicator while the section is fetched
    content.setAttribute('aria-busy', 'true')
    content.innerHTML = this.loadingHTML

    await window.BAO.sectionRenderer
      .fetchSingle('back-in-stock', trigger.dataset.productUrl)
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        content.innerHTML = myself.innerHTML
      })
      .catch(() => {
        content.innerHTML = `<p class="prd-BackInStock_Error">${this.errorMessage}</p>`
      })
      .finally(() => {
        content.setAttribute('aria-busy', 'false')
      })
  }

  get errorMessage () {
    return (
      this.dataset.errorMessage || 'Something went wrong. Please try again.'
    )
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
